<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Participation 1st Zonal Advisory Meeting</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.president_club"
              label="President of the Club"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.secretary_club"
              label="Secretary of the Club"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.treasurer_club"
              label="Treasurer of the Club"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-switch
              v-model="form.membership_director_club"
              label="Membership Director of the club"
              value="1"
              hide-details
            ></v-switch>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <DatePicker
              :lable="'Date*'"
              v-model="form.date"
              :setectVale="form.date"
              @changeInput="form.date = $event"
            ></DatePicker>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.no_of_officers_attended"
              label="No of officers attended"
              required
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Attach a copy of proof"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Photo"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.president_club"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import DatePicker from "@/components/shared/DatePicker";

export default {
  name: "FirstZonalAdvisory",

  components: { Alert, DatePicker },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      president_club: 0,
      date: null,
      secretary_club: 0,
      treasurer_club: 0,
      regular_meetings_schedule: 0,
      membership_director_club: 0,
      no_of_officers_attended: null,
      document1: null,
      document2: null,
    },

    url: "first-zonal-advisories",
  }),

  mounted() {},

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();

      fd.append("document1", this.form.document1);
      fd.append("document2", this.form.document2);

      fd.append("president_club", this.form.president_club == null ? 0 : this.form.president_club);
      fd.append("date", this.form.date);
      fd.append("secretary_club", this.form.secretary_club == null ? 0 : this.form.secretary_club);
      fd.append(
        "regular_meetings_schedule",
        this.form.regular_meetings_schedule
      );
      fd.append("treasurer_club", this.form.treasurer_club == null ? 0 : this.form.treasurer_club);
      fd.append("membership_director_club", this.form.membership_director_club == null ? 0 : this.form.membership_director_club);
      fd.append("no_of_officers_attended", this.form.no_of_officers_attended);
      fd.append("month", this.$route.params.month);
      fd.append("key", "FIRST_ZONAL_ADVISORIES");

      let data = fd;
      ActivityService.submitActivity(this.url, data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.$router.push("/activities/monthly");
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
